/* Geneva product page: gallery, options, quantity, zoom, mobile bar. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function init(root) {
    if (!root || root.dataset.ready) return; root.dataset.ready = '1';
    var slides = root.querySelectorAll('.gv-pdp__slide'), thumbs = root.querySelectorAll('[data-gv-thumb]');
    var cur = root.querySelector('[data-gv-current]'), idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      // Shape the stage to the image on screen (see the comment in gv-product.liquid).
      var stg = root.querySelector('.gv-pdp__stage'), ar = parseFloat(slides[idx].dataset.ar);
      if (stg && ar > 0) stg.style.setProperty('--gv-stage-ar', Math.min(2.8, Math.max(1, ar)).toFixed(3));
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      if (cur) cur.textContent = pad(idx + 1);
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gv-thumb]'); if (t) { show(+t.dataset.gvThumb); return; }
      var st = e.target.closest('[data-gv-step]'); if (st) { show(idx + +st.dataset.gvStep); return; }
      var q = e.target.closest('[data-gv-step-qty]');
      if (q) { var inp = q.parentElement.querySelector('input'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + +q.dataset.gvStepQty); return; }
      var z = e.target.closest('[data-gv-zoom]');
      if (z && dlg && srcs[idx]) { zimg.src = srcs[idx]; dlg.showModal(); return; }
      if (e.target.closest('[data-gv-zoom-close]') || e.target === dlg) { dlg.close(); return; }
      if (e.target.closest('[data-gv-bar-add]')) { var a = root.querySelector('.gv-pdp__add'); if (a) a.click(); return; }
      var ov = e.target.closest('.gv-opt__value'); if (ov) { pick(ov); }
    });
    // swipe on touch
    var stage = root.querySelector('.gv-pdp__stage'), x0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); x0 = null; });
    }
    root.addEventListener('keydown', function (e) { if (e.target.closest('.gv-pdp__stage')) { if (e.key === 'ArrowRight') show(idx + 1); if (e.key === 'ArrowLeft') show(idx - 1); } });

    // zoom
    var dlg = root.querySelector('[data-gv-zoom-dialog]'), zimg = root.querySelector('[data-gv-zoom-img]'), srcs = [];
    try { srcs = JSON.parse(root.querySelector('[data-gv-zoom-src]').textContent); } catch (e) {}

    // options -> variant
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-gv-variants]').textContent); } catch (e) {}
    var add = root.querySelector('.gv-pdp__add');
    function pick(btn) {
      var fs = btn.closest('.gv-opt');
      fs.querySelectorAll('.gv-opt__value').forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn); });
      var chosen = fs.querySelector('[data-gv-chosen]'); if (chosen) chosen.textContent = btn.dataset.value;
      var sel = [].map.call(root.querySelectorAll('.gv-opt'), function (f) { var a = f.querySelector('.is-active'); return a ? a.dataset.value : null; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v) return;
      if (add) { add.dataset.variant = v.title; add.dataset.variantId = v.id; }
      if (v.sku) root.querySelectorAll('[data-gv-sku]').forEach(function (el) { el.textContent = v.sku; });
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      // Jump the carousel to the image that belongs to this variant. When the variant has
      // no image of its own, fall back to the first image rather than leaving another
      // variant's photo on screen, which reads as the wrong product.
      var mid = v.media, si = -1;
      if (mid) slides.forEach(function (s, k) { if (+s.dataset.mediaId === +mid) si = k; });
      show(si >= 0 ? si : 0);
    }

    // mobile bar
    var bar = root.querySelector('[data-gv-bar]');
    if (bar && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on); bar.inert = !on; }).observe(add);
    }
  }
  function run() { document.querySelectorAll('[data-gv-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
